import React, { useState } from "react";
import "./FAQ.scss";
import { Accordion, Row, Col, useAccordionButton } from "react-bootstrap";
import { SlArrowDown as Plus } from "react-icons/sl";
import GradientUnderline from "../../../Components/GradientUnderline/GradientUnderline";

const QUESTIONS = [
  {
    eventKey: 0,
    id: "q1",
    question: "How can I purchase my ticket for ZiXXar Paradise?",
    answer: (
      <>
        To purchase your ticket for ZiXXar Paradise, you can head directly to
        the shop and visit the platform shop/tickets.
      </>
    ),
  },
  {
    eventKey: 1,
    id: "q2",
    question:
      "What differentiates the ZiXXar Private Event from regular ZiXXar Events?",
    answer:
      "The critical distinction between the ZiXXar Private Event and the standard ZiXXar Event lies in its immersive experience and focus on personal development. At the Private Event, attendees engage in various activities designed to foster growth and deepen their understanding of their potential in life. It's a unique opportunity to participate and truly evolve and discover new facets of oneself.",
  },
  {
    eventKey: 2,
    id: "q3",
    question: "Are there different ticket options?",
    answer: "No, there is only one type of ticket available for this event.",
  },

  {
    eventKey: 3,
    id: "q4",
    question: "What is the maximum reimbursement limit?",
    answer:
      "The maximum reimbursement limit is 700 USDT, specifically allocated for transportation expenses.",
  },
  {
    eventKey: 4,
    id: "q5",
    question: "When will the sales for the event close?",
    answer:
      "The sales for the event will close one month before the actual event takes place.",
  },

  {
    eventKey: 5,
    id: "q6",
    question:
      "What type of equipment do I need to bring for the entertainment activities?",
    answer:
      "For the entertainment activities, be prepared for numerous sports activities. Get ready to kick back, put your feet in the sand, and have a blast!",
  },

  {
    eventKey: 6,
    id: "q7",
    question:
      "How the discount will work for Travel Master Octarine & Live Pot Octarine",
    answer:
      "Owners of these Octarines will have the extra discount automatically applicable for their account.",
  },
];

function CustomToggle({ children, eventKey, activeId, setId, setActiveId }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    setActiveId(activeId === setId ? "" : setId)
  );

  return (
    <span className="custom-toggle" onClick={decoratedOnClick}>
      {children}
    </span>
  );
}

const FAQ = () => {
  const [activeId, setActiveId] = useState("q1");

  return (
    <div id="event-faq" className="section-margins position-relative">
      <div className="large-container d-flex align-items-start justify-content-start flex-column gap-5">
        <div className="d-flex align-items-start justify-content-start flex-column gap-2 w-100">
          <h2 className="font-pnb font-size-64 text-white">FAQ.</h2>
          <GradientUnderline />
          <span className="font-size-18 font-pnr color-light-grey">
            Our comprehensive FAQ section is here to help
          </span>
        </div>

        <Accordion className="dark-grey-color w-100" defaultActiveKey="0">
          <Row xs={1} sm={1} md={1} lg={1} xl={2}>
            <Col>
              {QUESTIONS.slice(0, QUESTIONS.length / 2).map((el, index) => {
                return (
                  <Accordion.Item
                    eventKey={el.eventKey}
                    key={el.id}
                    id={`${activeId === el.id ? "active-item" : ""}`}
                  >
                    <Accordion.Header className=" white-color font-pnsb mb-10px py-2">
                      <CustomToggle
                        eventKey={`${index}`}
                        activeId={activeId}
                        setId={el.id}
                        setActiveId={setActiveId}
                      >
                        <div className="white-color font-size-24 font-pnsb mb-10px large-container w-100 d-flex align-items-center justify-content-between ">
                          {el.question}
                          <div>
                            <Plus className="button-transition" />
                          </div>
                        </div>{" "}
                      </CustomToggle>
                    </Accordion.Header>

                    <Accordion.Body>
                      <p className="large-container font-pnr font-size-18 line-height-18  white-color">
                        {el.answer}
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Col>
            <Col>
              {QUESTIONS.slice(QUESTIONS.length / 2).map((el, index) => {
                return (
                  <Accordion.Item
                    eventKey={el.eventKey}
                    key={el.id}
                    id={`${activeId === el.id ? "active-item" : ""}`}
                  >
                    <Accordion.Header className=" white-color font-pnsb mb-10px py-2">
                      <CustomToggle
                        eventKey={`${index}`}
                        activeId={activeId}
                        setId={el.id}
                        setActiveId={setActiveId}
                      >
                        <div className="white-color font-size-24 font-pnsb mb-10px large-container w-100 d-flex align-items-center justify-content-between ">
                          {el.question}
                          <div>
                            <Plus className="button-transition" />
                          </div>
                        </div>{" "}
                      </CustomToggle>
                    </Accordion.Header>

                    <Accordion.Body>
                      <p className="large-container font-pnr font-size-18 line-height-18  white-color">
                        {el.answer}
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Col>
          </Row>
        </Accordion>
      </div>
    </div>
  );
};

export default FAQ;
